import React from 'react';
import config from './../../../services/config.json';
import Counter from './../../products/counter/Counter';
import NumberFormat from 'react-number-format';
import { useContext } from 'react';
import SimpleContext from './../../context/SimpleContext';

const ProductLev2 = ({ 
  name, 
  price, 
  slug, 
  min, 
  max, 
  numUnit,
  unit, 
  userPrice, 
  stock, 
  category, 
  numSale,
  ulImg,
  dlImg,
  urImg,
  drImg,
  isSahmiyeh,
  mojud,
  isvalid,
  goodsRef,
  uniqueid,
  Role
}) =>{

  const context = useContext(SimpleContext);

  let ImageEffect = 'card-img-top';
  if (stock === 0 || stock === numSale){
    ImageEffect = 'card-img-top-namojud';
  }

    return(
    <div className="card" onClick={()=>context.handleShowTrhsFilteredBySlugName(slug)}>
      <div className="card-image-place" onClick={()=>context.handleShowSimpleProduct(slug, stock, numSale)}>
          <img className={ImageEffect} 
          src={`${config.AndroidProductsPictures}/${slug}.jpg`} 
          alt=""
          />
          {
          stock===0 || stock===numSale?
            <img className="card-img-namojud img-thumbnail" src={`${config.DiscountImage}/${"notavailable.png"}`} alt=""/>
          :
          isSahmiyeh !== 0 ?
            <img className="card-img-namojud img-thumbnail" src={`${config.DiscountImage}/${"sahmiyeh.png"}`} alt=""/>
          :
            <img className="card-img-mini_UL img-thumbnail" src={`${config.DiscountImage}/${ulImg}`} alt=""/>
          } 

          <img className="card-img-mini_UR img-thumbnail" src={`${config.DiscountImage}/${urImg}`} alt=""/>
          <img className="card-img-mini_DL img-thumbnail" src={`${config.DiscountImage}/${dlImg}`} alt=""/>
          <img className="card-img-mini_DR img-thumbnail" src={`${config.DiscountImage}/${drImg}`} alt=""/>
        {/* <img className="card-img-namojud img-thumbnail" src={`${config.DiscountImage}/${"tamamshod.png"}`} alt=""/> */}
      </div>
      
      <div className="card-body" onClick={()=>context.handleShowSimpleProduct(slug, stock, numSale)}>
        <div className="cardtxt">
        <p className="card-text">{name}<br/><br/>
          قیمت پایه<br/>
          <NumberFormat value={price} displayType={'text'} thousandSeparator={true} /> ريال<br/><br/>
          قیمت مصرف کننده<br/>
          <NumberFormat value={userPrice} displayType={'text'} thousandSeparator={true} /> ريال </p>
        </div>
      </div>
      <Counter Role={Role} min={min} max={max} unit={unit} numUnit={numUnit} price={price} slug={slug} name={name} stock={stock} numSale={numSale} goodsRef={goodsRef} uniqueid={uniqueid}/>
    </div>   
  );
}
export default ProductLev2;